import React from 'react';
import { Typography } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export default function SectionTitle(props: Props) {
  const { children } = props;
  return (
    <Typography
      variant="h6"
      sx={{ mb: 2, fontWeight: 'bold', color: 'primary.main' }}
    >
      {children}
    </Typography>
  );
}
